// src/components/ProtectedRoute.js
import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

function ProtectedRoute({ children }) {
    const { user, loading } = useContext(AuthContext);
    const location = useLocation();

    // 1. Enquanto o AuthContext verifica o localStorage (fração de segundo), mostra um spinner
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#FFF5EE]">
                <div className="w-12 h-12 border-4 border-[#dbcdac] border-t-[#971253] rounded-full animate-spin"></div>
            </div>
        );
    }

    // 2. Se não há usuário logado, manda pro login e salva a página que ele tentou acessar
    if (!user) {
        // Salvamos de onde ele veio no state, para redirecioná-lo de volta pós-login, se desejar
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // 3. O PULO DO GATO: Se logou com Google mas não tem o telefone confirmado, trava no SignUp!
    if (user.isNewUser) {
        return <Navigate to="/signup" replace />;
    }

    // 4. Se passou por todas as barreiras, libera o acesso ao componente filho
    return children;
}

export default ProtectedRoute;